import {A360ProductModel} from 'Quoting/models/Quoting';
import React, {Fragment} from 'react';
import {TabView} from '../shared/Tab/TabView';
import {ViewAgenciesCompensation} from './AgenciesCompensation/ViewAgenciesCompensation';
import {PlansTab} from './Plan/PlansTab';
import {GPLUPolicySummary} from './PolicySummary/GPLUPolicySummary';
import {PolicySummaryTab} from './PolicySummary/PolicySummaryTab';
import {QuoteFormErrorDrawer} from './QuoteFormErrorDrawer';
import {isA360HealthProduct} from 'Quoting/utils/utilities';

const getQuoteFormTabs = (productModel: A360ProductModel, _planCd?: string) => [
  {title: 'Policy Summary', content: isA360HealthProduct(productModel) ? <PolicySummaryTab /> : <GPLUPolicySummary />},
  {title: 'Plans', content: <PlansTab />},
  {title: 'Producers & Compensation', content: <ViewAgenciesCompensation />},
];

export const MultiStepQuoteForm = ({productModel, planCd}: {productModel: A360ProductModel; planCd?: string}) => {
  return (
    <Fragment>
      <TabView tabs={getQuoteFormTabs(productModel, planCd)} ariaLabel="quote-form" withBottomNavigation />
      <QuoteFormErrorDrawer />
    </Fragment>
  );
};
